import React, { Component } from 'react';
import WithRouter from 'custom/withRouter';
import TaxRateList from './TaxRateList';
import TaxRateSave from './TaxRateSave';

class TaxRatePage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const p = this.props;
        const taxrateId = p.params.id;
        const isSave = taxrateId || p.location.pathname === "/manage/taxrate/add";

        return (
            <React.Fragment>
                {
                    isSave
                        ?
                        <TaxRateSave
                            name="taxrateSave"
                            params={p.params}
                            title="Tax Rate Info" />
                        :
                        <TaxRateList title="List of Taxes Rate" />
                }
            </React.Fragment>
        );
    }
}

export default WithRouter(TaxRatePage);